var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 50,
    viewBox: "0 0 96 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_955_2803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 82,
    height: 36,
    rx: 18,
    fill: "#043293"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5303 25.229L33.4094 24.9868C32.9 24.9284 32.399 25.1037 32.0399 25.4628L30.5035 26.9992C28.1404 25.7968 26.2032 23.8679 25.0008 21.4964L26.5455 19.9517C26.9046 19.5926 27.08 19.0916 27.0215 18.5822L26.7793 16.478C26.6791 15.6346 25.9694 15 25.1177 15H23.6731C22.7295 15 21.9446 15.7849 22.0031 16.7285C22.4456 23.8595 28.1488 29.5544 35.2714 29.9969C36.215 30.0554 36.9999 29.2705 36.9999 28.3269V26.8823C37.0083 26.0389 36.3737 25.3292 35.5303 25.229Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5759 27.9971C53.1242 27.9971 55.0168 26.5776 55.4152 24.3779H53.8962C53.5143 25.7642 52.2443 26.6191 50.5759 26.6191C48.2682 26.6191 46.8239 24.7349 46.8239 21.73C46.8239 18.7251 48.2682 16.8325 50.5676 16.8325C52.2194 16.8325 53.4977 17.8037 53.8962 19.3477H55.4152C55.0583 17.04 53.091 15.4546 50.5676 15.4546C47.3137 15.4546 45.2883 17.8618 45.2883 21.73C45.2883 25.5898 47.322 27.9971 50.5759 27.9971ZM60.0873 26.6191C59.0497 26.6191 58.2777 26.0879 58.2777 25.1748C58.2777 24.2783 58.8754 23.8052 60.2367 23.7139L62.6439 23.5562V24.3779C62.6439 25.6562 61.5565 26.6191 60.0873 26.6191ZM59.8217 27.8726C61.017 27.8726 61.9965 27.3496 62.5775 26.395H62.7103V27.7148H64.0717V21.5889C64.0717 19.7295 62.8515 18.6089 60.6684 18.6089C58.7592 18.6089 57.348 19.5552 57.1571 20.9912H58.6015C58.8007 20.2856 59.5477 19.8789 60.6186 19.8789C61.955 19.8789 62.6439 20.4849 62.6439 21.5889V22.4023L60.0624 22.5601C57.9789 22.6846 56.8002 23.606 56.8002 25.208C56.8002 26.8433 58.0868 27.8726 59.8217 27.8726ZM66.3863 27.7148H67.8141V15.2139H66.3863V27.7148ZM70.2615 27.7148H71.6893V15.2139H70.2615V27.7148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_955_2803",
    x: 0,
    y: 0,
    width: 96,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_955_2803"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 0 0.278431 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_955_2803"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.101961 0 0 0 0 0.294118 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_955_2803",
    result: "effect2_dropShadow_955_2803"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_955_2803",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallHospital);
export default __webpack_public_path__ + "static/media/call-hospital.fdd364cd1e68bfb17f034a33f7662197.svg";
export { ForwardRef as ReactComponent };